import type { FormHotkeyBarDefinition } from '../../utils/buildFormHotkeyBarItems';

/** Atajos de factura (clásica y POS): mismos F4–F9 + F2/ESC. */
export const FACTURA_HOTKEY_BAR_DEFINITIONS: FormHotkeyBarDefinition[] = [
  {
    id: 'F4',
    caption: 'Dtos/Inc x Linea',
    tooltip:
      'Editar descuento o incremento línea por línea (vuelve a presionar para la siguiente)',
  },
  {
    id: 'F9',
    caption: 'Fact. Cotizaciones',
    tooltip: 'Buscar y facturar una cotización',
  },
  {
    id: 'F6',
    caption: 'Fact. Pedidos',
    tooltip: 'Buscar y facturar un pedido',
  },
  {
    id: 'F8',
    caption: 'Fact. P. En Esp.',
    tooltip: 'Buscar pendientes / pedidos en espera',
  },
  {
    id: 'F7',
    caption: 'Bonif Recargos',
    tooltip: 'Abrir totales → Desc 1→2→3 → cerrar (repetible)',
  },
  {
    id: 'F2',
    caption: 'Aceptar',
    tooltip: 'Guardar la factura',
    variant: 'accept',
  },
  {
    id: 'Escape',
    caption: 'Cancelar',
    tooltip: 'Pide confirmación y vuelve sin guardar (Enter confirma)',
    variant: 'cancel',
  },
];
